// extracted by mini-css-extract-plugin
export default {"list":"MyShoplistEditor_list__MyWES","dark":"MyShoplistEditor_dark__51BuI"};